/**
 * @class
 * @name PriceObject
 *
 * @property {String} finalPrice
 * @property {String} finalPriceFormatted
 * @property {Number} originalPrice
 * @property {String} unitPrice
 * @property {Number} savings
 * @property {Number} validUntil
 * @property {String} currency
 * @property {Boolean} showUnitPrice
 */
class PriceObject {
  // Do not add any methods or constructor to this class
}

export default PriceObject
